import React from "react";
import { Navigate, Outlet, Route, useParams } from "react-router-dom";

import {
  NotFoundNavigation,
  NotFoundRedirectRoutes,
} from "components/NotFound";
import { toGlobalId } from "lib/Relay";

import { idParamName, idPath, overviewPath, workspacePath } from "./paths";
import { WorkspaceLayout } from "./WorkspaceLayout";

export const useWorkspaceId = (decoded?: boolean) => {
  const id = useParams()[idParamName];
  if (!id) {
    throw new Error("Workspace id not specified");
  }
  return decoded ? id : toGlobalId({ type: "RetailWorkspace", id });
};

const BaseRoute = () => {
  const id = useParams<{ [idParamName]: string }>()[idParamName];
  return !id || isNaN(Number(id)) ? <NotFoundNavigation /> : <Outlet />;
};

const Overview = React.lazy(() => import("./Overview"));
const OverviewRoute = () => <Overview workspaceId={useWorkspaceId()} />;

const WorkspaceRoute = () => (
  <WorkspaceLayout>
    <Outlet />
  </WorkspaceLayout>
);

export const Routes = (
  <Route path={workspacePath} element={<BaseRoute />}>
    <Route path={idPath} element={<WorkspaceRoute />}>
      <Route path={overviewPath} element={<OverviewRoute />} />
      <Route path="*" element={<Navigate to={overviewPath} replace />} />
      <Route index element={<Navigate to={overviewPath} replace />} />
    </Route>
    {NotFoundRedirectRoutes /* MUST BE LAST! see `NotFoundRedirectRoutes`*/}
  </Route>
);
